import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    align: "middle",
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        "txt-center": "",
        span: 12
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/signup/founder" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                "is-borderless": ""
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Create Founder Profile ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        "txt-center": "",
        span: 12
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_link, {
            target: "_blank",
            href: _ctx.aboutTalentsAccount
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Talents Get Invited ?", -1)
            ]))]),
            _: 1
          }, 8, ["href"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}